import { Service } from "models/Service";

export class SpaceDebat extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: `Debates - Clarin.com`,
        keywords: "",
        title: `Debates - Clarin.com`,
        url: `debates`,
        extra: [],
      },
      section: "debates",
      sectionName: "Debates",
      template: "SpaceDebat",
      title: `Debates`,
      widthFull: false,
      slug: "",
      titleHeader: "Debates",
      hideSubHeadSectionBox: true,
      enableHeader: true,
      hideSectionScroll: true,
      classService: "logora-service",
      showBannerH1App: false,
      isTitleHeader: true,
    });
  }
}
